module.exports = __webpack_public_path__ + "assets/img/btn-view-870bf83c.png";